module.exports = __webpack_public_path__ + "f4042eb4a9711fcae6ea657d5728ec0f.svg";